export const login = function (location, oidc) {
    let oidcUrl = `${oidc.url}?client_id=${encodeURIComponent(oidc.clientID)}&redirect_uri=${encodeURIComponent(oidc.redirectURI)}&response_type=${encodeURIComponent(oidc.responseType)}&nonce=${encodeURIComponent(oidc.nonce)}&scope=${encodeURIComponent(oidc.scope.join(" "))}`;
    location.assign(oidcUrl);
};
export const checkToken = function (s) {
    return parseTokenInQueryOrHash(s);
};
function parseTokenInQueryOrHash(s) {
    if (!s) {
        return undefined;
    }
    if (!(s[0] == "?" || s[0] == "#")) {
        return undefined;
    }
    let ss = s.substr(1);
    let map = ss
        .split("&")
        .map((v) => v.split("="))
        .reduce((pre, [key, value]) => (Object.assign(Object.assign({}, pre), { [key]: value })), {});
    return map["id_token"];
}
